import { t } from 'i18next';
import * as yup from 'yup';
import { AnyObjectSchema } from 'yup';

import { ICompanySettings } from 'auth/types';
import { upsertCustomerQuoteSchema } from 'quotes/components/CustomerQuoteUpsert';
import { upsertVendorQuoteSchema } from 'quotes/components/VendorQuoteUpsert';
import { QuoteEntityType, QuoteType } from 'quotes/enums';

import { ItemsToCopyField } from './enums';

interface IProps {
  selectedQuoteId?: number;
  fromQuoteType: QuoteType;
  addToQuoteType: QuoteType;
  entityType?: QuoteEntityType;
  companySettings?: ICompanySettings;
  itemsToCopyValues: ItemsToCopyField[];
  isAlternateVersionEnabled?: boolean;
}

export const getSchema = ({
  selectedQuoteId,
  fromQuoteType,
  addToQuoteType,
  itemsToCopyValues,
  entityType,
  companySettings,
  isAlternateVersionEnabled,
}: IProps) => {
  const baseSchema = selectItemsToCopySchema(itemsToCopyValues, fromQuoteType);

  if (selectedQuoteId) {
    return baseSchema;
  }

  switch (addToQuoteType) {
    case QuoteType.VENDOR:
      return upsertVendorQuoteSchema(entityType).concat(baseSchema);
    case QuoteType.CUSTOMER:
    default:
      return (
        upsertCustomerQuoteSchema({
          entityType,
          companySettings,
          isEdit: false,
          isAlternateVersionEnabled,
        }) as AnyObjectSchema
      ).concat(baseSchema);
  }
};

export const selectItemsToCopySchema = (
  itemsToCopyValues: ItemsToCopyField[],
  fromQuoteType: QuoteType
) =>
  yup.object().shape({
    ...(QuoteType.VENDOR === fromQuoteType && {
      attachQuote: yup.boolean().label(t('labelAttachAsVendorQuote')).nullable(),
    }),
    ...itemsToCopyValues.reduce((acc, value) => {
      acc[value] = yup.boolean().nullable();

      if (
        [ItemsToCopyField.QUOTE_CUSTOMER_NOTE, ItemsToCopyField.QUOTE_INTERNAL_NOTE].includes(value)
      ) {
        acc[`${value}Type`] = yup.string().nullable();
      }

      return acc;
    }, {}),
  });
